const removeWhiteSpace = (string: String | null) => {
  return string?.replace(/[\n\r]+|[\s]{2,}/g, " ").trim();
};

window.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".js-category-button");
  const articles = document.querySelectorAll(".js-nested-link");
  const linkContainer = document.querySelector(".js-button-container");
  const component = document.querySelector(".js-quick-links");
  const linkList: string[] = [];

  if (!(links instanceof NodeList)) {
    return;
  }

  if (!(articles instanceof NodeList)) {
    return;
  }
  links.forEach((link) => {
    const linkType = removeWhiteSpace(link.textContent);
    if (!linkList.includes(linkType!)) {
      linkList.push(linkType!);
    } else {
      link.remove();
    }
    articles.forEach((article) => {
      const articleType = removeWhiteSpace(
        article.querySelector(".tags")!?.textContent
      );

      if (linkType === articleType || articleType?.includes(linkType!)) {
        link.classList.remove("hidden");
      }

      link.addEventListener("click", (e) => {
        e.preventDefault();
        if (!articleType?.includes(linkType!)) {
          article.classList.add("hidden");
        } else {
          article.classList.remove("hidden");
        }
      });
    });
  });
  links.forEach((link) => {
    if (link.classList.contains("hidden")) {
      link.remove();
    }
  });
  if (linkContainer!?.children.length == 0) {
    component?.classList.add("hidden");
  }
});
